import React, {FC, useEffect} from 'react';

import AemButton from '@/components/Aem/AemButton';
import {AEM_EXTERNAL_LINK_TYPES} from '@/consts/externalLinkTypes';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {useJourneyLevelAction} from '@/hooks/loyalty/dataHooks';
import appContent from '@/services/content/appContent';
import {getAchievedBadgeImage} from '@/services/loyalty/badgeUtils';
import {LoyaltyActionInfoType} from '@/types/loyalty';
import {LoyaltyPopupTemplate} from '@/views/Loyalty/PopupTemplates/primitives';

interface INextTaskPopupTemplateProps {
    onClose?: () => void;
    onAction?: () => void;
    actionInfo?: LoyaltyActionInfoType;
    levelAction?: any;
}

export const NextTaskPopupTemplate: FC<INextTaskPopupTemplateProps> = ({
    levelAction,
    actionInfo,
    onAction,
    onClose,
}) => {
    const {primaryButton} = appContent.getNextTaskContent() || {};
    const action = useJourneyLevelAction(actionInfo) || levelAction;
    const {journeyBadge, actionDescription, actionLabel, actionURL} = action || {};
    const {alt, ...buttonProps} = primaryButton || {};

    const {redirectToExternalLink: redirect} = useConfigExternalLink({
        ssoUrl: actionURL,
        linkType: AEM_EXTERNAL_LINK_TYPES.URL,
    });

    useEffect(() => {
        if (!action) {
            onClose?.();
        }
    }, []);

    if (!action) {
        return null;
    }

    const handleActionClick = () => {
        onAction?.();
        redirect?.();
    };

    return (
        <LoyaltyPopupTemplate>
            <LoyaltyPopupTemplate.Header handleClose={onClose} />
            <LoyaltyPopupTemplate.Body>
                <LoyaltyPopupTemplate.Hero imageSrc={getAchievedBadgeImage(journeyBadge)?.imageURL}>
                    <LoyaltyPopupTemplate.Title>{journeyBadge.journeyName}</LoyaltyPopupTemplate.Title>
                </LoyaltyPopupTemplate.Hero>
                <LoyaltyPopupTemplate.Footer className='bg-charcoal'>
                    <div className='pr-5 text-16 font-normal'>
                        <p className='text-tertiary'>{actionLabel}</p>
                        <p className='text-white'>{actionDescription}</p>
                    </div>
                </LoyaltyPopupTemplate.Footer>
                <AemButton
                    aria-label={alt}
                    primary
                    dark
                    className='m-0 w-full px-6 py-3'
                    {...buttonProps}
                    onClick={handleActionClick}
                />
            </LoyaltyPopupTemplate.Body>
        </LoyaltyPopupTemplate>
    );
};
